// Public Expert Profile Page
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import BrowsePros from './BrowsePros';
import SingleProProfile from '../../../components/singlePro';
import { PublicShareContainer } from './components/PublicShareContainer';

export default function ShareExperts() {
  const [searchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState<Record<string, string>>({});

  useEffect(() => {
    const paramsObj: Record<string, string> = {};
    for (const [key, value] of searchParams.entries()) {
      paramsObj[key] = value;
    }
    setQueryParams(paramsObj);
  }, [searchParams]);

  const title = `meet the expert${!searchParams.get('proId') ? 's' : ''}`;

  const descriptionContent = (
    <>
      <Typography variant="body2" color="darkgray1">
        The Desire Company connects brands with credentialed experts who share real, firsthand product experience. Every expert you see here is vetted for credibility, category expertise, and on-camera clarity, helping brands build trust, improve conversion, and perform across retail and media channels.
      </Typography>
      <Typography
        variant="body2"
        color="darkgray1"
        textTransform="uppercase"
      >
        Credentialed Experts Brands Rely On
      </Typography>
    </>
  );

  return (
    <PublicShareContainer
      title={title}
      descriptionContent={descriptionContent}
      unwrap={!!searchParams.get('proId')}
    >
      {!searchParams.get('proId') ? (
        <BrowsePros
          isSharePath
          showShortlistFilter={false}
          showDialog={false}
          setShowDialog={() => { }}
          isExpertPage={false}
          isShortlistPage={false}
          queryParams={queryParams}
        />
      ) : (
        <SingleProProfile isSharePage />
      )}
    </PublicShareContainer>
  );
}
